import { Route } from '@angular/router';
import { pagePermissionActivate } from '../page-permission';

/** Essentials under `/essentials/...` (default: `essentials/locale`). */
export const essentialsRoutes: Route = {
    path: 'essentials',
    data: { title: 'essentials' },
    children: [
        { path: '', pathMatch: 'full', redirectTo: 'locale' },
        {
            path: 'locale',
            loadComponent: () => import('./locale/locale.component').then((m) => m.LocaleComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'locale' },
        },
        {
            path: 'locator',
            loadComponent: () => import('./locator/locator.component').then((m) => m.LocatorComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'locator' },
        },
        {
            path: 'timezone',
            loadComponent: () => import('./timezone/timezone.component').then((m) => m.TimezoneComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'timezone' },
        },
        {
            path: 'unit',
            loadComponent: () => import('./unit/unit.component').then((m) => m.UnitComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'unit' },
        },
        {
            path: 'app',
            loadComponent: () => import('./application/application.component').then((m) => m.ApplicationComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'app' },
        },
        {
            path: 'file',
            loadComponent: () => import('./file/file.component').then((m) => m.FileComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'File' },
        },
        {
            path: 'file-type',
            loadComponent: () => import('./file-type/file-type.component').then((m) => m.FileTypeComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'File type' },
        },
        {
            path: 'unit-type',
            loadComponent: () => import('./unit-type/unit-type.component').then((m) => m.UnitTypeComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Unit type' },
        },
        {
            path: 'unit-user',
            loadComponent: () => import('./unit-user/unit-user.component').then((m) => m.UnitUserComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Unit user' },
        },
    ],
};
